import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { Tooltip } from 'element-ui'
import StartLastService from '@/views/StartLastService.vue'
import StartLastService2 from '@/views/StartLastService2.vue'
import ServiceList from '@/views/ServiceList.vue'
import ServiceList2 from '@/views/ServiceList2.vue'
import ServiceList3 from '@/views/ServiceList3.vue'

Vue.component(Tooltip.name, Tooltip)

Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.config.productionTip = false

new Vue({
//  router,
  store,
  components: {
    ServiceList,
    ServiceList2,
    ServiceList3,
    StartLastService,
    StartLastService2
  }
  // render: h => h(App)
}).$mount('#huluer-vue-app')
